export const ENABLED_AUTO_RECORDING = 'local';
export const DISABLED_AUTO_RECORDING = 'none';
